import moment from "moment/moment";
import React, { Component } from 'react'
import matchSorter from 'match-sorter'
import { Header, Icon , Button, Divider, Modal} from 'semantic-ui-react'

//import {getLicenseId, getLicenseName} from '../../common/licenseHelper'
import ReactTable from 'react-table'
import UserAdd from "../../containers/Users/UserAdd";
import UserEdit from "../../containers/Users/UserEdit";
import {getLicenseId} from "../../common/licenseHelper";

class UserTable extends Component {
    constructor(props) {
        super(props)
        this.columns = [
            {
                Header: "Full name",
                accessor: "fullname",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["fullname"]}),
                filterAll: true,
                width: 300


            },
            {
                Header: "Email",
                accessor: "email",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["email"]}),
                filterAll: true

            },
            {
                Header: "Company",
                accessor: "company",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["company"]}),
                filterAll: true

            },

            {
                Header: "Admin",
                accessor: "admin",
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["admin"]}),
                filterAll: true,
                Cell: ({row, value}) => {
                    if (value === 1) return <i className="check icon"></i>
                    else return <div></div>
                },
                width: 60,
            },

            {
                Header: "Last updated",
                id: "create_date",
                accessor: (row) => moment(row.create_date, "DD.MM.YYYY HH:mm:ss").format("YYYY.MM.DD HH:mm:ss").toString(),
                width:150,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["create_date"], threshold: matchSorter.rankings.CONTAINS}),
                filterAll: true

            },


            {
                Header: "Action",
                accessor: "id",
                width:80,
                Filter: () => <React.Fragment></React.Fragment>,
                Cell: ({row,value}) => (
                    <div>
                        <UserEdit rowId={value} userId={row.email} data={{
                            ...row,
                            email_user: row.email

                        }}


                                  />
                    </div>

                        /*<UserDel rowId={value} userId={row.email} />*/
                )

            }
        ];

    }

    render() {
        const {data} = this.props;
        return (
            <ReactTable
                filterable
                data={data}
                columns={this.columns}
                defaultFilterMethod={(filter, row) =>
                    row[filter.id] !== undefined &&
                    String(row[filter.id]).toLowerCase().includes(String(filter.value).toLowerCase())}
                defaultSorted={[
                    {
                        id: "create_date",
                        desc:true
                    }
                ]}
                defaultPageSize={20}
                className="-striped -highlight"/>
        )
    }
}



export default class UserList extends Component {

    constructor(props) {
        super(props);

    }
    componentWillMount() {
        this.setState({
            open : false
        });
    }

    show = () =>  this.setState({ open: true })
    close = () => this.setState({ open: false })

    render() {
        const {data, isAdmin} = this.props;
        const {open} = this.state;
        return (
            <React.Fragment>

                <Header as='h2'>
                    <Icon name='user'/>
                    <Header.Content>
                        User Management
                    </Header.Content>
                </Header>
                <Button compact onClick={this.show} disabled={!isAdmin}>
                    <Header as='h4'>
                        <Icon.Group size='large'>
                            <Icon name='user'/>
                            <Icon corner name='plus'/>
                        </Icon.Group>
                        Add new user
                    </Header>
                </Button>
                <Divider hidden/>

                <UserAdd open={open} onClose={this.close}
                         initialValues={{

                         }}/>

                <UserTable data={data} />

            </React.Fragment>
        )

    }
}
